import Component from '@glimmer/component'
import { service } from '@ember/service'

interface HeroContainerArgs {
  Blocks: {
    default: []
  }
  Element: HTMLElement
}

export default class HeroContainer extends Component<HeroContainerArgs> {
  @service flowManager: FlowManager

  get hero() {
    return this.flowManager.activeFlow?.activePage?.hero
  }

  get settings() {
    const activePage = this.flowManager.activeFlow?.activePage
    return activePage?.settings ?? {}
  }

  <template>
    <this.hero @pageSettings={{this.settings}}>
      {{yield}}
    </this.hero>
  </template>
}
